<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » アップロードファイル一覧の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>アップロードファイル一覧の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/uploader.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択したファイルを削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ファイル選択
        </div>
        <div class="manual-explain">
          ファイルをシステムにアップロードします。<br>
          ファイルを選択ボタンからアップロードするか、またはドラッグ&ドロップでもアップロード可能です。<br>
          <span class="manual-explain-notes">
            ※ファイルを選択する前に「画像圧縮」を選択してください。<br>
            &nbsp;&nbsp;圧縮方式は「圧縮する（500KB以下へ）」「圧縮する（640px以下へ）」「圧縮しない」が選択可能です。<br>
            &nbsp;&nbsp;画像のサイズが大きいほど通信料が掛かりユーザーの負担となりますので、圧縮することをお勧めします。<br>
          </span>
          <span>
            ※各画像についての推奨サイズ（縦横比）は以下になります。<br>
            &nbsp;&nbsp;ロゴ画像：1 : 4.5（例）高さ約150px、幅700px<br>
            &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px<br>
          </span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          アップロードファイル一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: 名称
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> アップロードファイル一覧
        </div>
        <div class="manual-explain">
          アップロード済みファイルの一覧が表示されます。<br>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Top</a> » Uploaded Files List Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Uploaded Files List Description</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_uploader.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected files.<br>
          The button is activated when you check the delete checkbox in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> File Selection
        </div>
        <div class="manual-explain">
          Upload files to the system.<br>
          You can upload files by clicking the "Select File" button or by drag-and-drop.<br>
          <span class="manual-explain-notes">
            ※ Before selecting a file, choose an "Image Compression" option.<br>
            &nbsp;&nbsp;You can select from "Compress (under 500KB)", "Compress (under 640px)", or "Do not
            compress".<br>
            &nbsp;&nbsp;Larger image sizes increase data usage and may burden users, so compression is recommended.<br>
          </span>
          <span>
            ※ Recommended sizes (aspect ratios) for each image are as follows:<br>
            &nbsp;&nbsp;Logo Image: 1 : 4.5 (e.g., height ~150px, width 700px)<br>
            &nbsp;&nbsp;Main Image: 1 : 1 (e.g., height 1400px, width 1400px)<br>
          </span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filter the data displayed in the uploaded files list.<br>
          ※ Filter target: Name
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Uploaded Files List
        </div>
        <div class="manual-explain">
          Displays a list of uploaded files.<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>